import { useState } from "react"
import top from '../../../assets/icons/top-arrow.png'
import bottom from '../../../assets/icons/bottom-arrow.png'

const QuestionCollapse = ({q,a,className}) => {

    const [answer, setAnswer] = useState(false)

    const handleClick = () => {

        answer?setAnswer(false):setAnswer(true)

    }
    
    return(
        <div className={`${className?className:'col-span-2 md:col-span-1'}
          bg-white rounded rounded-xl lg:rounded-2xl px-4 py-4 min-h-[52px] `}>
            <div
            onClick={handleClick}
            className={`flex justify-between items-center cursor-pointer
             ${answer?'':'h-full'} gap-1`}>
                <div className="flex items-center px-2 gap-2">
                <span className="w-1.5 h-1.5 mt-[2px] rounded-full bg-aqua 
                text-transparent">
                    2
                </span>
                <h4 className="text-[13px] lg:text-[15px] font-medium">
                    {q}
                </h4>
                </div>
                <span>
                    <img
                    src={answer?top:bottom}
                    className="w-[9px] lg:w-2.5 opacity-70 me-1"
                    
                    />
                </span>
            </div>
            {answer?
            <p className="text-justify mt-2 px-2 text-[12.5px] 
            lg:text-[14.5px] text-black/65">
            {a}
            </p>
            :''}
        </div>
    )
}

export default QuestionCollapse